module.exports = __webpack_public_path__ + "img/goods2.97135677.png";